import { render, staticRenderFns } from "./MaterialListPage.vue?vue&type=template&id=0be09846&scoped=true&"
import script from "./MaterialListPage.vue?vue&type=script&lang=js&"
export * from "./MaterialListPage.vue?vue&type=script&lang=js&"
import style0 from "./MaterialListPage.vue?vue&type=style&index=0&id=0be09846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be09846",
  null
  
)

export default component.exports